import type { RootState } from "../types/store.types";

export const selectTemplates = (state: RootState) => state.reportTemplates.templates;
export const selectCompanies = (state: RootState) => state.reportTemplates.companies;
